/* Wires bundle radio cards to: hidden variant input, live price display, CTA label,
 * and the product media gallery (each pack has its own photo).
 * All numbers rendered here are read from data attributes emitted by Liquid from the
 * real Shopify variant - nothing here computes or simulates a price.
 */
(function () {
  'use strict';

  function labelForPack(qty) {
    if (qty >= 2) return 'ADD ' + qty + '-PACK TO CART';
    return (window.themeStrings && window.themeStrings.addToCart) || 'ADD TO CART';
  }

  function announceMedia(option) {
    var mediaId = option.getAttribute('data-variant-media-id');
    if (!mediaId) return;
    document.dispatchEvent(new CustomEvent('bundle:media', { detail: { mediaId: String(mediaId) } }));
  }

  function updatePriceDisplay(panel, option) {
    var priceEl = panel.querySelector('[data-selected-price]');
    if (!priceEl) return;
    var current = priceEl.querySelector('[data-price-current]');
    var compareWrap = priceEl.querySelector('[data-price-compare]');
    var savingsWrap = priceEl.querySelector('[data-price-savings]');

    if (current) current.textContent = option.getAttribute('data-variant-price-formatted');

    var compareFormatted = option.getAttribute('data-variant-compare-formatted');
    var savingsFormatted = option.getAttribute('data-variant-savings-formatted');

    if (compareFormatted && savingsFormatted) {
      if (!compareWrap) {
        compareWrap = document.createElement('span');
        compareWrap.className = 'price-display__compare';
        compareWrap.setAttribute('data-price-compare', '');
        current.insertAdjacentElement('afterend', compareWrap);
      }
      compareWrap.textContent = compareFormatted;
      compareWrap.style.display = '';

      if (!savingsWrap) {
        savingsWrap = document.createElement('span');
        savingsWrap.className = 'badge badge-soft';
        savingsWrap.setAttribute('data-price-savings', '');
        priceEl.querySelector('.price-display').appendChild(savingsWrap);
      }
      savingsWrap.textContent = 'You Save ' + savingsFormatted;
      savingsWrap.style.display = '';
    } else {
      if (compareWrap) compareWrap.style.display = 'none';
      if (savingsWrap) savingsWrap.style.display = 'none';
    }
  }

  function variantInput(scope) {
    return scope.querySelector('[data-selected-variant-input]') || scope.querySelector('input[name="id"]');
  }

  function selectOption(panel, option) {
    var selector = panel.querySelector('[data-bundle-selector]');
    if (!selector) return;

    selector.querySelectorAll('[data-bundle-option]').forEach(function (el) {
      el.classList.toggle('is-selected', el === option);
    });

    var variantId = option.getAttribute('data-variant-id');
    var packQty = parseInt(option.getAttribute('data-pack-qty'), 10) || 1;
    var available = !option.classList.contains('is-soldout');

    var input = variantInput(panel);
    if (input) input.value = variantId;

    var ctaBtn = panel.querySelector('[data-add-to-cart]');
    var ctaLabel = panel.querySelector('[data-cta-label]');
    if (ctaLabel) ctaLabel.textContent = available ? labelForPack(packQty) : 'SOLD OUT';
    if (ctaBtn) ctaBtn.disabled = !available;

    updatePriceDisplay(panel, option);
    announceMedia(option);

    document.querySelectorAll('product-purchase-panel').forEach(function (other) {
      if (other === panel) return;
      var match = other.querySelector('[data-bundle-option][data-pack-qty="' + packQty + '"]');
      if (match) selectOptionSilently(other, match);
    });
  }

  function selectOptionSilently(panel, option) {
    var selector = panel.querySelector('[data-bundle-selector]');
    if (selector) {
      selector.querySelectorAll('[data-bundle-option]').forEach(function (el) {
        el.classList.toggle('is-selected', el === option);
      });
      var radio = option.querySelector('[data-bundle-radio]');
      if (radio) radio.checked = true;
    }
    var input = variantInput(panel);
    if (input) input.value = option.getAttribute('data-variant-id');
    var packQty = parseInt(option.getAttribute('data-pack-qty'), 10) || 1;
    var ctaLabel = panel.querySelector('[data-cta-label]');
    var available = !option.classList.contains('is-soldout');
    if (ctaLabel) ctaLabel.textContent = available ? labelForPack(packQty) : 'SOLD OUT';
    updatePriceDisplay(panel, option);
  }

  function initPanel(panel) {
    if (panel.dataset.bundleInit) return;
    panel.dataset.bundleInit = 'true';

    panel.addEventListener('change', function (e) {
      var target = e.target;
      if (!target || typeof target.closest !== 'function') return;
      var radio = target.closest('[data-bundle-radio]');
      if (!radio) return;
      var option = radio.closest('[data-bundle-option]');
      if (!option) return;
      selectOption(panel, option);
      if (typeof window.trackEvent === 'function') {
        window.trackEvent('bundle_selected', { variant_id: option.getAttribute('data-variant-id'), pack_qty: option.getAttribute('data-pack-qty') });
      }
    });

    // The Liquid `{% form %}` tag may drop the data-product-form attribute, so fall back
    // to the real add-to-cart form inside the panel rather than losing the submit handler.
    var form = panel.querySelector('[data-product-form]')
      || panel.querySelector('form[action*="/cart/add"]')
      || panel.querySelector('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        var btn = form.querySelector('[data-add-to-cart]');
        var input = variantInput(form);

        // Always resync the posted variant id with whatever pack is actually checked.
        var checked = panel.querySelector('[data-bundle-radio]:checked');
        if (!checked) {
          var selectedCard = panel.querySelector('[data-bundle-option].is-selected');
          if (selectedCard) checked = selectedCard.querySelector('[data-bundle-radio]');
        }
        if (checked && input && checked.value) input.value = checked.value;

        var variantId = input && input.value;
        if (!variantId || (btn && btn.disabled)) { e.preventDefault(); return; }

        // If the cart JS failed to load, let the browser do a native POST to /cart/add
        // instead of silently doing nothing.
        if (!window.CartAPI || typeof window.CartAPI.addItem !== 'function') return;

        e.preventDefault();
        if (btn) {
          btn.classList.add('btn-loading');
          btn.disabled = true;
        }
        window.CartAPI.addItem(variantId, 1)
          .catch(function () {})
          .finally(function () {
            if (btn) {
              btn.classList.remove('btn-loading');
              btn.disabled = false;
            }
          });
      });
    }
  }

  function syncInitialMedia() {
    var selected = document.querySelector('product-purchase-panel [data-bundle-option].is-selected[data-variant-media-id]');
    if (selected) announceMedia(selected);
  }

  function init(root) {
    (root || document).querySelectorAll('product-purchase-panel').forEach(initPanel);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); syncInitialMedia(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
